import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  ButtonsContainer,
  CaseContainer,
  MenuContainer,
} from './styles';
import Icon from '../../assets/icons';
import { notification, Breadcrumb } from 'antd';
import { theme } from '../../../global';

type TLink = {
  title: string;
  href?: string;
};

type TPageContainer = {
  menuLinks: TLink[];
  children: ReactNode;
  isWide?: boolean;
};

const PageContainer = ({ menuLinks, children, isWide }: TPageContainer) => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification({
    getContainer: () => document.getElementById('main') as HTMLElement,
  });

  const copyToClip = async () => {
    await navigator.clipboard.writeText(window.location.href);
    api.open({
      message: 'Link copied',
      placement: 'top',
      icon: <Icon variant='copy' />,
      style: {
        border: `0.94px solid ${theme.colors.greenLight}`,
        padding: `${theme.spacings.s16}`,
        gap: `${theme.spacings.s16}`,
        borderRadius: `${theme.spacings.s8}`,
        width: '187px',
        height: '52px',
        background: '#A1BF9E0A',
      },
    });
  };

  return (
    <CaseContainer $isWide={isWide}>
      <ButtonsContainer>
        <Button onClick={() => navigate(-1)}>
          <Icon variant='arrowLeft' />
        </Button>
        {contextHolder}
        <Button onClick={copyToClip}>
          <Icon variant='share' />
        </Button>
      </ButtonsContainer>
      <MenuContainer>
        <Breadcrumb
          separator={<Icon variant='arrowRight' />}
          items={menuLinks}
        />
      </MenuContainer>
      {children}
    </CaseContainer>
  );
};

export default PageContainer;
